import FilterCheckboxChip, {
    FilterCheckboxChipMetric,
} from 'components/FilterChips/FilterCheckboxChip';
import FilterSelect from 'components/Input/FilterSelect';
import Stack from 'components/Stack';
import { formatVolume } from 'utils/helpers';
import { getOnChange } from 'components/SectionTableFilterChips';
import styled from 'styled-components';
import useFlavorGroups from './useFlavorGroups';

const menus = ['flavorGroups'];

function TopFlavorGroups({
    filters,
    setFilters,
    category,
    country,
    dataSource,
    order_by,
    ascending,
}) {
    const groupsQuery = useFlavorGroups({
        category,
        country,
        dataSource,
        order_by,
        ascending,
    });
    const topGroups = groupsQuery.data?.topGroups;
    if (!topGroups && !groupsQuery.isLoading) return null;
    if (!topGroups && groupsQuery.isLoading) {
        return (
            <FilterCheckboxChip
                disabled={true}
                isLoading={true}
                checked={false}
            />
        );
    }
    return (
        <>
            {topGroups.map((group) => {
                const isChecked = !!filters.flavorGroups
                    ?.map(({ value }) => value)
                    .includes(group.textId);
                const onChange = (e) => {
                    const newFilters = !isChecked
                        ? [
                              ...(filters.flavorGroups || []),
                              { value: group.textId },
                          ]
                        : (filters.flavorGroups || []).filter(
                              ({ value }) => value !== group.textId,
                          );
                    setFilters({ ...filters, flavorGroups: newFilters });
                };
                return (
                    <FilterCheckboxChip
                        key={group.textId}
                        checked={isChecked}
                        onChange={onChange}
                        preserveIconSpace={false}
                    >
                        <span>
                            {group.name}
                            <FilterCheckboxChipMetric>
                                {formatVolume(group.data?.[order_by])}
                            </FilterCheckboxChipMetric>
                        </span>
                    </FilterCheckboxChip>
                );
            })}
        </>
    );
}

const defaultMixpanelMeta = {
    contentKey: 'DataTable',
};

function FlavorGroups({
    filters,
    setFilter,
    setFilters,
    filtersKey,
    category,
    country,
    dataSource,
    order_by,
    ascending,
    mixpanelMeta = defaultMixpanelMeta,
}) {
    return (
        <Stack
            $space=".75rem"
            $direction="row"
            $wrap={true}
            css={`
                gap: 0.75rem 0;
            `}
        >
            <FilterSelect
                filters={filters}
                setFilter={setFilter}
                setFilters={setFilters}
                resetFilters={() => setFilters({})}
                filtersKey={filtersKey}
                mixpanelMeta={mixpanelMeta}
                menus={menus}
                getOnChange={getOnChange}
                menuAlign="left"
                queryData={{
                    category,
                    country,
                    dataSource,
                    order_by,
                    ascending,
                }}
            />
            <TopFlavorGroups
                filters={filters}
                setFilters={setFilters}
                category={category}
                country={country}
                dataSource={dataSource}
                order_by={order_by}
                ascending={ascending}
            />
        </Stack>
    );
}

export default FlavorGroups;
